import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { getCurrentCulture } from "@utils";

export const FullStatistics = observer(function FullStatistics() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (!store.sportStatisticsStore.betRadarStats) {
		return null;
	}

	const srcUrl = `https://s5.sir.sportradar.com/tipwin/${getCurrentCulture()}${`/match/${store.sportStatisticsStore.betRadarStats}`}`;

	if (store?.displayStatisticsGroup === StatisticsGroups.FullStats) {
		return (
			<div className="statistics__card statistics--full-stats">
				<iframe
					id="statistics-frame"
					src={srcUrl}
					frameBorder="0"
					className="statistics--full-stats__iframe"
				/>
			</div>
		);
	}

	return null;
});
